import './MGMyModalities.css'

//COMPONENT
import MGCardList from '../MGCardList/MGCardList';

export default function MGMyModalities({ myModalities, leftTitle, rightTitle, rightColor = "#222324" }) {

    return (
        <div className='MGMyModalities-container'>
            <h4>As minhas modalidades</h4>
            <MGCardList items={myModalities.productTypes}
                leftTitle={leftTitle}
                rightTitle={rightTitle}
                rightColor={rightColor} />
        </div>
    );
}